// Google place types for a whole area or road (a colony, nagar, town, street)
// rather than one spot. Google gives such places a single label point, so a
// fare priced to it can fall well short of where the rider actually goes.
const AREA_PLACE_TYPES = new Set([
  'neighborhood',
  'sublocality',
  'sublocality_level_1',
  'sublocality_level_2',
  'sublocality_level_3',
  'sublocality_level_4',
  'sublocality_level_5',
  'locality',
  'colloquial_area',
  'route',
  'postal_code',
  'administrative_area_level_1',
  'administrative_area_level_2',
  'administrative_area_level_3',
]);

// Anything that is also a specific building, shop or address is exact enough.
const EXACT_PLACE_TYPES = new Set([
  'establishment',
  'point_of_interest',
  'premise',
  'subpremise',
  'street_address',
]);

export const isAreaPlace = (types) => Array.isArray(types)
  && types.some((type) => AREA_PLACE_TYPES.has(type))
  && !types.some((type) => EXACT_PLACE_TYPES.has(type));
